import i18next from "src/i18n/config";

import { Typography } from "@mui/material";
import TimeService from "@services/timeService/timeService";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { Tooltip } from "@shared/Tooltip";
import { createColumnHelper } from "@tanstack/react-table";

import { ActionCell, ActionCellProps } from "./components/TableCells";
import { VisibilityCellProps } from "./components/VisibilityCell";
import { VisibilityCell } from "./components/VisibilityCell";

type ProductTableData = {
    id: number;
    workspaceId: number;
    groupId: number | null;
    name: string;
    codename: string;
    creationDate: string;
    builds: number;
    androidVersion: string;
    visibility: VisibilityCellProps;
    actions: ActionCellProps;
};

const columnHelper = createColumnHelper<ProductTableData>();

export const tableColumns = [
    columnHelper.accessor("id", {
        id: "id",
        enableSorting: true,
        header: "ID",
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
    }),
    columnHelper.accessor("workspaceId", {
        id: "workspaceId",
        enableSorting: true,
        header: () => (
            <Tooltip title={i18next.t("common:label.workspaceId")} placement="top">
                <span style={{ fontWeight: 600 }}>WID</span>
            </Tooltip>
        ),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
    }),
    columnHelper.accessor("groupId", {
        id: "groupId",
        enableSorting: true,
        header: () => (
            <Tooltip title={i18next.t("common:label.groupId")} placement="top">
                <span style={{ fontWeight: 600 }}>GID</span>
            </Tooltip>
        ),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue() ?? "-"}</Typography>
            </MinimalTableCell>
        ),
    }),
    columnHelper.accessor("name", {
        id: "name",
        header: i18next.t("common:label.name"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("codename", {
        id: "codename",
        header: i18next.t("common:label.codename"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("creationDate", {
        id: "creationDate",
        header: i18next.t("common:label.creationDate"),
        cell: (info) => (
            <MinimalTableCell>
                <Tooltip title={TimeService.getLocalDate(info.row.original.creationDate, "ISO", "dateTime")}>
                    <Typography>{TimeService.getLocalDate(info.row.original.creationDate, "ISO", "date")}</Typography>
                </Tooltip>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("androidVersion", {
        id: "androidVersion",
        header: i18next.t("common:label.androidVersion"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("builds", {
        id: "builds",
        header: i18next.t("common:label.builds"),
        cell: (info) => (
            <MinimalTableCell>
                <Typography>{info.getValue()}</Typography>
            </MinimalTableCell>
        ),
        enableSorting: true,
    }),
    columnHelper.accessor("visibility", {
        id: "visibility",
        header: i18next.t("common:label.visibility"),
        cell: (info) => <VisibilityCell {...info.getValue()} />,
        enableSorting: false,
    }),
    columnHelper.accessor("actions", {
        id: "actions",
        header: "",
        cell: (info) => <ActionCell {...info.getValue()} />,
        enableSorting: false,
    }),
];
